import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import likeMutation, { likeCommentMutation, likeCommentMutationVariables } from '../mutations/like.graphql';
import unlikeMutation, { unlikeCommentMutation, unlikeCommentMutationVariables } from '../mutations/unlike.graphql';

import { LikeUnlikeCommentFragment } from '../mutations/like-unlike-comment.graphql';

export interface Props extends LikeUnlikeCommentFragment {
    children: (likeComment: () => Promise<any>, unlikeComment: () => Promise<any>) => React.ReactNode;
}

class LikeUnlikeComment extends React.PureComponent<Props> {
    render() {
        const { id, isLikedByViewer, likesCount } = this.props;

        return (
            <Mutation<likeCommentMutation, likeCommentMutationVariables>
                mutation={likeMutation}
                optimisticResponse={{
                    likeComment: {
                        __typename: 'LikeCommentPayload',
                        comment: {
                            __typename: 'CommentNode',
                            id,
                            isLikedByViewer: !isLikedByViewer,
                            likesCount: (likesCount || 0) + 1,
                        },
                    },
                }}
            >
                {likeComment => (
                    <Mutation<unlikeCommentMutation, unlikeCommentMutationVariables>
                        mutation={unlikeMutation}
                        optimisticResponse={{
                            unlikeComment: {
                                __typename: 'UnlikeCommentPayload',
                                comment: {
                                    __typename: 'CommentNode',
                                    id,
                                    isLikedByViewer: !isLikedByViewer,
                                    likesCount: (likesCount || 1) - 1,
                                },
                            },
                        }}
                    >
                        {unlikeComment =>
                            this.props.children(
                                () => likeComment({ variables: { id } }),
                                () => unlikeComment({ variables: { id } })
                            ) as any
                        }
                    </Mutation>
                )}
            </Mutation>
        );
    }
}

export default LikeUnlikeComment;
